import createReducer, {
  createCollectionStatusReducer,
  createCollectionReducer,
  mergeById
} from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import persistReducer from '../utils/persistReducer';

const list = createCollectionReducer(
  ActionTypes.FETCH_JOB_SUCCESS,
  ActionTypes.FETCH_JOB_STATUS_SUCCESS,
  ActionTypes.POST_JOB_SUCCESS
);
const invitations = createCollectionReducer(ActionTypes.FETCH_JOB_INVITATIONS_SUCCESS);

const connections = createCollectionReducer(
  ActionTypes.FETCH_JOB_CONNECTIONS_SUCCESS,
  ActionTypes.UPDATE_CONNECTION
);

const status = createCollectionStatusReducer(
  ActionTypes.FETCH_JOB_REQUEST,
  ActionTypes.FETCH_JOB_SUCCESS,
  ActionTypes.FETCH_JOB_NOT_FOUND,
  ActionTypes.FETCH_JOB_ERROR
);

const checkpoints = persistReducer(
  'jobs.checkpoints',
  createReducer(
    {},
    {
      [ActionTypes.MARK_CHECKPOINT]: mergeById,
      [ActionTypes.UNMARK_CHECKPOINT]: (state, { payload }) => {
        delete state[payload.id];
        return state;
      }
    }
  )
);

const connectMoreStatus = createCollectionStatusReducer(
  ActionTypes.JOB_CONNECT_MORE_REQUEST,
  ActionTypes.JOB_CONNECT_MORE_SUCCESS,
  ActionTypes.JOB_CONNECT_MORE_ERROR
);

const invitationStatus = createCollectionStatusReducer(
  ActionTypes.FETCH_JOB_INVITATIONS_REQUEST,
  ActionTypes.FETCH_JOB_INVITATIONS_SUCCESS,
  ActionTypes.FETCH_JOB_INVITATIONS_ERROR
);

const connectionStatus = createCollectionStatusReducer(
  ActionTypes.FETCH_JOB_CONNECTIONS_REQUEST,
  ActionTypes.FETCH_JOB_CONNECTIONS_SUCCESS,
  ActionTypes.FETCH_JOB_CONNECTIONS_ERROR
);

const connectionWaitlistStatus = createCollectionStatusReducer(
  ActionTypes.CONNECTION_ADD_WAITLIST_REQUEST,
  ActionTypes.CONNECTION_ADD_WAITLIST_SUCCESS,
  ActionTypes.CONNECTION_ADD_WAITLIST_ERROR
);

const isFirstView = createCollectionReducer(ActionTypes.SET_IS_FIRST_VIEW);

const closeJob = createReducer(
  {},
  {
    [ActionTypes.CLOSE_JOB_SUCCESS]: (state, { payload }) => payload
  }
);

export default combineReducers({
  list,
  checkpoints,
  invitations,
  connections,
  status,
  invitationStatus,
  connectMoreStatus,
  connectionStatus,
  isFirstView,
  closeJob,
  connectionWaitlistStatus
});
